import ApiError from '../../api/apiError';
import { env } from '../../env';

const { PERFORMANCE_PLATFORM_INFO } = env.runtimeConfig.backend;

const configureFetchLegacyPermissions = (token: string, fetch = window.fetch) => () =>
    fetch(`${PERFORMANCE_PLATFORM_INFO}/permissions`, {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
        },
        method: 'GET',
    }).then(res => {
        if (!res.ok) {
            throw new ApiError(res.status, `Error during "legacy permissions" call: ${res.status} - ${res.statusText}`);
        }

        return res.json();
    });

export default configureFetchLegacyPermissions;
